import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { useState } from "react";
import { FormServiceFieldHandlingExecuteCodeWhenNoTagManagerConsentIsGiven } from "./executeCodeWhenNoTagManagerConsentIsGiven.js";
import { FormServiceFieldHandlingSkipIfActiveNotice } from "./skipIfActiveNotice.js";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormValueDifferFromTemplateTag } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldHandlingCodeOptIn = ()=>{
    const { __ } = useI18n();
    const { renderCodeMirror } = useFormService();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Code executed on opt-in"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "codeOptIn",
                        noStyle: true,
                        children: renderCodeMirror()
                    }),
                    /*#__PURE__*/ _jsx(FormServiceFieldHandlingSkipIfActiveNotice, {
                        name: "codeOptIn"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        ref: setRef,
                        children: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                            style: {
                                marginTop: 10
                            },
                            form: "service",
                            valueName: "codeOptIn",
                            widthOfRef: ref,
                            noBr: true,
                            splitView: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingExecuteCodeWhenNoTagManagerConsentIsGiven, {
                name: "executeCodeOptInWhenNoTagManagerConsentIsGiven"
            })
        ]
    });
};
export { FormServiceFieldHandlingCodeOptIn };
